<app-mobile-collapsible-section [title]="mobileSectionTitle()">
    <svg collapsibleIcon width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_44311_3294)">
        <path d="M12.114 1.42029H8.94589C8.6855 0.594203 7.90433 0 6.99296 0C6.0816 0 5.31489 0.594203 5.04004 1.42029H1.90088C1.23544 1.42029 0.700195 1.95652 0.700195 2.62319V12.7971C0.700195 13.4638 1.23544 14 1.90088 14H12.0995C12.7649 14 13.3002 13.4638 13.3002 12.7971V2.62319C13.3002 1.95652 12.7649 1.42029 12.114 1.42029ZM6.99296 1.33333C7.38355 1.33333 7.7018 1.65217 7.7018 2.04348C7.7018 2.43478 7.38355 2.75362 6.99296 2.75362C6.60238 2.75362 6.28412 2.43478 6.28412 2.04348C6.28412 1.65217 6.60238 1.33333 6.99296 1.33333ZM10.5661 11.4348C10.5661 11.6087 10.4214 11.7536 10.2478 11.7536H7.47035H6.53005H3.76702C3.59342 11.7536 3.44876 11.6087 3.44876 11.4348V10.7536C3.44876 10.5362 3.55002 10.3333 3.70915 10.2029C4.62052 9.44928 5.60421 8.95652 5.79227 8.85507C5.82121 8.84058 5.82121 8.82609 5.82121 8.7971V8.10145C5.71994 7.91304 5.64761 7.72464 5.61868 7.55072C5.54635 7.55072 5.44509 7.43478 5.32936 7.04348C5.1847 6.55072 5.31489 6.44928 5.44509 6.44928C5.43062 6.4058 5.41615 6.36232 5.41615 6.31884C5.37276 6.07246 5.35829 5.84058 5.41615 5.62319C5.48848 5.33333 5.64761 5.08696 5.82121 4.89855C5.93693 4.78261 6.06713 4.66667 6.19733 4.57971C6.31305 4.50725 6.42878 4.43478 6.55898 4.3913C6.66024 4.36232 6.77597 4.33333 6.8917 4.33333C7.25335 4.30435 7.52821 4.3913 7.73074 4.50725C8.02006 4.66667 8.13579 4.88406 8.13579 4.88406C8.13579 4.88406 8.8157 4.92754 8.58424 6.30435C8.56977 6.34783 8.56977 6.3913 8.55531 6.43478C8.6855 6.43478 8.81569 6.53623 8.67103 7.02899C8.55531 7.42029 8.45404 7.52174 8.38171 7.53623C8.35278 7.71014 8.28045 7.91304 8.17919 8.08696V8.78261C8.17919 8.81159 8.19365 8.82609 8.22258 8.84058C8.42511 8.94203 9.39434 9.43478 10.3057 10.1884C10.4648 10.3188 10.5661 10.5217 10.5661 10.7391V11.4348Z" fill="#6B7280"/>
        </g>
        <defs>
        <clipPath id="clip0_44311_3294">
        <rect width="14" height="14" fill="white"/>
        </clipPath>
        </defs>
    </svg>
    <div collapsibleBody>
        <div class="tw-flex tw-flex-col tw-gap-3">
          @if (personasTotal() && personasTotal() > 0 && canCreatePersona()) {
            <button
              type="button"
              class="tw-flex tw-items-center tw-gap-2 tw-text-blue-600 tw-text-sm tw-font-medium tw-w-fit"
              [class.!tw-cursor-not-allowed]="readonly()"
              (click)="openCreatePersonaModal()"
            >
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_42744_117654)">
                    <path d="M11.3333 5.33333H6.66667V0.666667C6.66667 0.489856 6.59643 0.320286 6.4714 0.195262C6.34638 0.0702379 6.17681 0 6 0C5.82319 0 5.65362 0.0702379 5.5286 0.195262C5.40357 0.320286 5.33333 0.489856 5.33333 0.666667V5.33333H0.666667C0.489856 5.33333 0.320286 5.40357 0.195262 5.5286C0.0702379 5.65362 0 5.82319 0 6C0 6.17681 0.0702379 6.34638 0.195262 6.4714C0.320286 6.59643 0.489856 6.66667 0.666667 6.66667H5.33333V11.3333C5.33333 11.5101 5.40357 11.6797 5.5286 11.8047C5.65362 11.9298 5.82319 12 6 12C6.17681 12 6.34638 11.9298 6.4714 11.8047C6.59643 11.6797 6.66667 11.5101 6.66667 11.3333V6.66667H11.3333C11.5101 6.66667 11.6797 6.59643 11.8047 6.4714C11.9298 6.34638 12 6.17681 12 6C12 5.82319 11.9298 5.65362 11.8047 5.5286C11.6797 5.40357 11.5101 5.33333 11.3333 5.33333Z" fill="#1C64F2"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_42744_117654">
                    <rect width="12" height="12" fill="white"/>
                    </clipPath>
                    </defs>
                </svg>
                Add New
            </button>
          }
            <div
                #mobilePersonasScrollRoot
                [class.event-personas-mobile-scroll]="personaPaginationEnabled() && !showMobilePersonasEmpty()"
            >
            <div class="tw-flex tw-flex-col tw-gap-2">
                @if (showMobilePersonasSkeleton()) {
                    @for (item of [1, 2, 3]; track item) {
                        <div class="tw-h-[74px] tw-w-full tw-rounded-lg tw-border tw-border-gray-100 tw-bg-white tw-p-3">
                            <div class="tw-flex tw-items-center tw-gap-3">
                                <div class="persona-skeleton-shimmer tw-h-10 tw-w-10 tw-rounded-full"></div>
                                <div class="tw-flex-1 tw-space-y-2">
                                    <div class="persona-skeleton-shimmer tw-h-3 tw-w-2/3 tw-rounded"></div>
                                    <div class="persona-skeleton-shimmer persona-skeleton-shimmer--muted tw-h-3 tw-w-1/3 tw-rounded"></div>
                                </div>
                            </div>
                        </div>
                    }
                } @else if (showMobilePersonasEmpty() && canCreatePersona()) {
                    <div class="lg:tw-hidden tw-mt-4 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-6">
                        <img src="/assets/images/v2/noPersonas.svg" alt="" />
                        <div>
                            <h1 class="tw-text-lg tw-text-gray-900 tw-font-bold tw-text-center tw-mb-2 tw-font-inter">No Attendee Personas yet!</h1>
                            <p class="tw-text-center tw-text-gray-500 tw-font-medium tw-text-sm">Start by creating your first Attendee Personas to build custom registration forms, attendee journeys, and confirmations.</p>
                        </div>
                        <button
                         type="button"
                         class="tw-font-inter tw-bg-blue-600 tw-text-white tw-text-sm tw-font-medium tw-rounded-lg tw-px-5 tw-py-2.5 tw-flex tw-items-center tw-justify-center tw-gap-2 tw-h-10 tw-w-full"
                         [class.!tw-cursor-not-allowed]="readonly()"
                         (click)="openCreatePersonaModal()"
                        >
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_44401_1081)">
                                <path d="M13.2222 6.22222H7.77778V0.777778C7.77778 0.571498 7.69583 0.373667 7.54997 0.227806C7.40411 0.0819442 7.20628 0 7 0C6.79372 0 6.59589 0.0819442 6.45003 0.227806C6.30417 0.373667 6.22222 0.571498 6.22222 0.777778V6.22222H0.777778C0.571498 6.22222 0.373667 6.30417 0.227806 6.45003C0.0819442 6.59589 0 6.79372 0 7C0 7.20628 0.0819442 7.40411 0.227806 7.54997C0.373667 7.69583 0.571498 7.77778 0.777778 7.77778H6.22222V13.2222C6.22222 13.4285 6.30417 13.6263 6.45003 13.7722C6.59589 13.9181 6.79372 14 7 14C7.20628 14 7.40411 13.9181 7.54997 13.7722C7.69583 13.6263 7.77778 13.4285 7.77778 13.2222V7.77778H13.2222C13.4285 7.77778 13.6263 7.69583 13.7722 7.54997C13.9181 7.40411 14 7.20628 14 7C14 6.79372 13.9181 6.59589 13.7722 6.45003C13.6263 6.30417 13.4285 6.22222 13.2222 6.22222Z" fill="white"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_44401_1081">
                                <rect width="14" height="14" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg>
                            Create first persona
                        </button>
                    </div>
                } @else {
                    @for (persona of displayPersonasForMobile(); track persona.id) {
                        <app-mobile-persona-card
                            [persona]="persona"
                            [personaNameControl]="getPersonaNameControl(persona)"
                            [personaMenuOptions]="personaMenuOptions()"
                            [menuDropdownHeight]="mobilePersonaMenuDropdownHeight()"
                            [readonly]="readonly()"
                            [basicInputMode]="BasicInputMode"
                            (personaNameBlur)="handlePersonaNameBlur(persona)"
                            (personaNameKeydown)="handlePersonaNameKeydown($event)"
                            (personaMenuOption)="onPersonaMenuOption(persona, $event)"
                            (landingPageClick)="onPersonaLandingPageClick(persona)"
                            (manageClick)="onMobilePersonaManageClick(persona)"
                        ></app-mobile-persona-card>
                    }
                    @if (personaPaginationEnabled() && mobileHasMorePersonas()) {
                        <div #mobileLoadMoreTrigger class="tw-h-8 tw-w-full tw-shrink-0" aria-hidden="true"></div>
                    }
                    @if (personaPaginationEnabled() && mobileListLoading() && mobilePersonaList().length) {
                        <progress-circle [isInfinite]="true" class="tw-flex tw-items-center tw-justify-center tw-py-2" colorClasses="tw-border-blue-500 tw-border-r-gray-300"></progress-circle>
                    }
                }
            </div>
            </div>
        </div>
    </div>
</app-mobile-collapsible-section>

<div class="tw-flex-col tw-h-full tw-hidden lg:tw-flex tw-gap-2">
    <div class="tw-flex tw-items-center tw-justify-between tw-h-[21px]">
        <div class="tw-flex tw-items-center tw-gap-2">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_43294_123298)">
                <path d="M15.5752 1.82609H11.502C11.1672 0.763975 10.1628 0 8.99109 0C7.81933 0 6.83357 0.763975 6.48018 1.82609H2.44413C1.58857 1.82609 0.900391 2.51553 0.900391 3.37267V16.4534C0.900391 17.3106 1.58857 18 2.44413 18H15.5566C16.4122 18 17.1004 17.3106 17.1004 16.4534V3.37267C17.1004 2.51553 16.4122 1.82609 15.5752 1.82609ZM8.99109 1.71429C9.49327 1.71429 9.90246 2.12422 9.90246 2.62733C9.90246 3.13043 9.49327 3.54037 8.99109 3.54037C8.48891 3.54037 8.07972 3.13043 8.07972 2.62733C8.07972 2.12422 8.48891 1.71429 8.99109 1.71429ZM13.5851 14.7019C13.5851 14.9255 13.3991 15.1118 13.1759 15.1118H9.60487H8.39591H4.84344C4.62025 15.1118 4.43426 14.9255 4.43426 14.7019V13.8261C4.43426 13.5466 4.56446 13.2857 4.76905 13.118C5.9408 12.1491 7.20556 11.5155 7.44735 11.3851C7.48455 11.3665 7.48455 11.3478 7.48455 11.3106V10.4161C7.35435 10.1739 7.26136 9.93168 7.22416 9.70807C7.13116 9.70807 7.00097 9.559 6.85217 9.0559C6.66618 8.42236 6.83357 8.29192 7.00096 8.29192C6.98237 8.23602 6.96377 8.18012 6.96377 8.12422C6.90797 7.80745 6.88937 7.50932 6.96377 7.22981C7.05676 6.85714 7.26135 6.54037 7.48455 6.29814C7.63334 6.14907 7.80074 6 7.96813 5.8882C8.11692 5.79503 8.26572 5.70186 8.43311 5.64596C8.56331 5.6087 8.7121 5.57143 8.8609 5.57143C9.32588 5.53416 9.67927 5.64596 9.93966 5.79503C10.3116 6 10.4604 6.2795 10.4604 6.2795C10.4604 6.2795 11.3346 6.3354 11.037 8.10559C11.0184 8.16149 11.0184 8.21739 10.9998 8.27329C11.1672 8.27329 11.3346 8.40373 11.1486 9.03727C10.9998 9.54037 10.8696 9.67081 10.7766 9.68944C10.7394 9.91304 10.6464 10.1739 10.5162 10.3975V11.2919C10.5162 11.3292 10.5348 11.3478 10.572 11.3665C10.8324 11.4969 12.0786 12.1304 13.2503 13.0994C13.4549 13.2671 13.5851 13.528 13.5851 13.8075V14.7019Z" fill="#6B7280"/>
                </g>
                <defs>
                <clipPath id="clip0_43294_123298">
                <rect width="18" height="18" fill="white"/>
                </clipPath>
                </defs>
            </svg>            
            <h1 class="tw-text-gray-900 tw-text-sm tw-font-bold tw-font-inter">@if (personasLoading()) {Attendee Personas <span class="persona-count-shimmer tw-inline-block tw-h-[1em] tw-min-w-[1.25rem] tw-rounded-[2px]" role="status" aria-label="Loading persona count"></span>} @else {Attendee Personas ({{ desktopTotalPersonasCount() }})}</h1>
        </div>
        @if (personasTotal() && personasTotal() > 0 && canViewPersonasList()) {
        <div class="tw-flex tw-max-h-[22px]">
  
            <!-- Add New Persona Button -->
            @if (canCreatePersona()) {
            <button
              class=" tw-text-blue-600 tw-font-inter tw-text-sm tw-font-medium tw-flex  tw-items-center tw-gap-1 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
              [class.!tw-cursor-not-allowed]="readonly()"
              (click)="openCreatePersonaModal()"
            >
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_42744_117654)">
                <path d="M11.3333 5.33333H6.66667V0.666667C6.66667 0.489856 6.59643 0.320286 6.4714 0.195262C6.34638 0.0702379 6.17681 0 6 0C5.82319 0 5.65362 0.0702379 5.5286 0.195262C5.40357 0.320286 5.33333 0.489856 5.33333 0.666667V5.33333H0.666667C0.489856 5.33333 0.320286 5.40357 0.195262 5.5286C0.0702379 5.65362 0 5.82319 0 6C0 6.17681 0.0702379 6.34638 0.195262 6.4714C0.320286 6.59643 0.489856 6.66667 0.666667 6.66667H5.33333V11.3333C5.33333 11.5101 5.40357 11.6797 5.5286 11.8047C5.65362 11.9298 5.82319 12 6 12C6.17681 12 6.34638 11.9298 6.4714 11.8047C6.59643 11.6797 6.66667 11.5101 6.66667 11.3333V6.66667H11.3333C11.5101 6.66667 11.6797 6.59643 11.8047 6.4714C11.9298 6.34638 12 6.17681 12 6C12 5.82319 11.9298 5.65362 11.8047 5.5286C11.6797 5.40357 11.5101 5.33333 11.3333 5.33333Z" fill="#1C64F2"/>
                </g>
                <defs>
                <clipPath id="clip0_42744_117654">
                <rect width="12" height="12" fill="white"/>
                </clipPath>
                </defs>
                </svg>
              Add New
            </button>
            <div class="tw-w-px tw-h-[18px] tw-bg-gray-200 tw-mt-3 tw-mx-2 tw-self-end"></div>
            }
            <button
            type="button"
            class=" tw-text-blue-600 tw-text-sm tw-font-medium tw-flex  tw-items-center tw-gap-1 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-font-inter"
              [class.!tw-cursor-not-allowed]="readonly()"
              (click)="navigateToPersonasWizard()"
            >
              View All
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.67863 12C3.44839 11.9999 3.22332 11.9296 3.0319 11.7979C2.84047 11.6662 2.69128 11.4791 2.60317 11.2601C2.51507 11.0411 2.49201 10.8002 2.53692 10.5677C2.58182 10.3353 2.69267 10.1217 2.85546 9.95411L6.68957 6.00736L2.85546 2.06061C2.74425 1.95005 2.65555 1.8178 2.59453 1.67158C2.53351 1.52535 2.50139 1.36808 2.50004 1.20894C2.4987 1.0498 2.52816 0.89198 2.5867 0.744686C2.64525 0.597391 2.7317 0.463573 2.84102 0.35104C2.95034 0.238507 3.08034 0.149513 3.22343 0.0892499C3.36653 0.0289869 3.51984 -0.00133763 3.67444 4.52529e-05C3.82904 0.00142813 3.98182 0.034491 4.12387 0.0973047C4.26593 0.160118 4.3944 0.251425 4.50181 0.365896L9.1591 5.16001C9.37738 5.38476 9.5 5.68956 9.5 6.00736C9.5 6.32517 9.37738 6.62997 9.1591 6.85472L4.50181 11.6488C4.28351 11.8736 3.9874 11.9999 3.67863 12Z" fill="#1C64F2"/>
                </svg>
            </button>
          </div>
        }
    </div>
    <div class="tw-flex tw-gap-3">
        @if (personasLoading()) {
            @for (item of desktopPersonaSkeletonSlots; track item) {
                <div class="tw-flex tw-flex-col tw-w-[72px] xl:tw-w-[102px] tw-h-[72px] tw-rounded-lg tw-border tw-border-gray-100 tw-overflow-hidden tw-bg-white">
                    <div class="persona-skeleton-shimmer persona-skeleton-shimmer--muted tw-h-5 tw-w-full"></div>
                    <div class="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1.5 tw-p-2">
                        <div class="persona-skeleton-shimmer tw-h-2.5 tw-w-10 tw-rounded"></div>
                        <div class="persona-skeleton-shimmer persona-skeleton-shimmer--muted tw-h-2.5 tw-w-6 tw-rounded"></div>
                    </div>
                </div>
            }
        } @else {
            @for (persona of desktopVisiblePersonas(); track persona.id) {
                <app-event-persona-card
                    [persona]="persona"
                    [personaMenuOptions]="desktopPersonaMenuOptions()"
                    [readonly]="readonly()"
                    (optionClicked)="onPersonaMenuOption(persona, $event)"
                    class="tw-w-[72px] xl:tw-w-[102px]"
                ></app-event-persona-card>
            }
            @if (desktopHiddenPersonaCount() > 0 && canViewPersonasList()) {
                <button
                    type="button"
                    [class.!tw-cursor-not-allowed]="readonly()"
                    class="tw-flex tw-items-center tw-justify-center tw-w-[25px] xl:tw-w-8 tw-h-[72px] tw-rounded-lg tw-bg-blue-100 tw-text-xs tw-text-blue-600 tw-font-semibold hover:tw-bg-blue-200 active:tw-bg-blue-700 active:tw-text-white"
                    [attr.aria-label]="'View remaining ' + desktopHiddenPersonaCount() + ' personas'"
                    (click)="navigateToPersonasWizard()"
                >
                    +{{ desktopHiddenPersonaCount() }}
                </button>
            } @else if (!desktopVisiblePersonas().length) {
                <button
                    type="button"
                    class="tw-flex tw-flex-col tw-items-stretch tw-w-[72px] xl:tw-w-[102px] tw-h-[72px] tw-border tw-border-blue-600 tw-border-dashed tw-rounded-lg tw-overflow-hidden tw-bg-white"
                    [attr.aria-label]="canCreatePersona() ? 'Add attendee persona' : 'No personas'"
                    [class.!tw-cursor-not-allowed]="readonly()"
                    (click)="openCreatePersonaModal()"
                >
                    <div class="tw-bg-blue-50 tw-h-5 tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-w-full">
                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="4" cy="4" r="3.40278" transform="matrix(1 0 0 -1 0 8)" fill="white" stroke="#1C64F2" stroke-width="1.19444"/>
                        </svg>
                    </div>
                    <div class="tw-flex tw-min-h-0 tw-flex-1 tw-w-full tw-items-center tw-justify-center tw-gap-1.5 tw-p-2 tw-font-inter tw-font-medium tw-text-gray-900">
                        @if (canCreatePersona()) {
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_44387_8822)">
                            <path d="M9.44444 4.44444H5.55556V0.555556C5.55556 0.408213 5.49702 0.266905 5.39284 0.162718C5.28865 0.0585316 5.14734 0 5 0C4.85266 0 4.71135 0.0585316 4.60716 0.162718C4.50298 0.266905 4.44444 0.408213 4.44444 0.555556V4.44444H0.555556C0.408213 4.44444 0.266905 4.50298 0.162718 4.60716C0.0585316 4.71135 0 4.85266 0 5C0 5.14734 0.0585316 5.28865 0.162718 5.39284C0.266905 5.49702 0.408213 5.55556 0.555556 5.55556H4.44444V9.44444C4.44444 9.59179 4.50298 9.7331 4.60716 9.83728C4.71135 9.94147 4.85266 10 5 10C5.14734 10 5.28865 9.94147 5.39284 9.83728C5.49702 9.7331 5.55556 9.59179 5.55556 9.44444V5.55556H9.44444C9.59179 5.55556 9.7331 5.49702 9.83728 5.39284C9.94147 5.28865 10 5.14734 10 5C10 4.85266 9.94147 4.71135 9.83728 4.60716C9.7331 4.50298 9.59179 4.44444 9.44444 4.44444Z" fill="#111928"/>
                            </g>
                            <defs>
                            <clipPath id="clip0_44387_8822">
                            <rect width="10" height="10" fill="white"/>
                            </clipPath>
                            </defs>
                        </svg> 
                        }
                        <span class="tw-text-xs tw-leading-none tw-font-medium tw-font-inter tw-text-gray-900">{{ canCreatePersona() ? 'Add' : 'No personas' }}</span>
                    </div>
                </button>
            }
        }
    </div>
</div>

@if (isModalOpened(createPersonaModalId)) {
    <create-persona-modal
      [id]="createPersonaModalId"
      [isSubmitting]="isCreatingPersona()"
      [apiErrorBody]="createPersonaApiError()"
      (onCreate)="onCreatePersonaSubmitted($event)"
      (onCancel)="cancelCreatePersonaModal()"
    ></create-persona-modal>
  }

@if (isModalOpened(clonePersonaModalId) && cloneSourcePersona(); as sourcePersona) {
  <clone-persona-modal
    [id]="clonePersonaModalId"
    [workspaceId]="event().workspace_id"
    [eventId]="event().id"
    [sourcePersona]="sourcePersona"
    [eventSlug]="event().slug ?? ''"
    (cloned)="onPersonaCloned($event)"
    (onCancel)="closeClonePersonaModal()"
  ></clone-persona-modal>
}

@if (isModalOpened(renamePersonaModalId)) {
  <create-persona-modal
    [id]="renamePersonaModalId"
    [headerText]="'Rename Persona'"
    [submitButtonText]="'Rename'"
    [initialName]="personaNameToRename()"
    [isSubmitting]="false"
    [apiErrorBody]="null"
    (onCreate)="onRenamePersonaSubmitted($event)"
    (onCancel)="cancelRenamePersonaModal()"
  ></create-persona-modal>
}

@if (isModalOpened(confirmArchivePersonaModalId)) {
  <modal
    [id]="confirmArchivePersonaModalId"
    [showFooterDivider]="false"
    [showHeaderDivider]="false"
    [widthClass]="'tw-w-auto lg:tw-w-[416px]'"
    [heightClass]="'tw-h-auto'"
    [closeButtonEnabled]="true"
    [enableBackdropClose]="true"
    (onCloseModal)="cancelArchivePersona()"
  >
    <div class="tw-flex tw-flex-col tw-gap-4 tw-items-center tw-justify-center tw-py-2" slot="body">
      <p class="tw-font-inter tw-text-gray-500 tw-px-4 tw-text-center tw-text-base tw-leading-6 tw-font-normal">
        Are you sure you want to archive <span class="tw-font-bold">{{ personaNameToArchive() }}</span> persona?
      </p>
      <p class="tw-font-inter tw-text-gray-500 tw-px-4 tw-text-center tw-text-base tw-leading-6 tw-font-normal">You can access archived items anytime from the event’s menu (⋯).</p>
    </div>
    <div class="tw-flex tw-justify-center tw-items-center tw-gap-2 tw-px-6 tw-pt-4 tw-pb-6" slot="footer">
        <button
          type="button"
          class="tw-flex tw-items-center tw-justify-center tw-text-white tw-bg-red-600 hover:tw-bg-red-700 focus:tw-ring-4 focus:tw-ring-red-300 tw-font-medium tw-rounded-md tw-text-sm focus:tw-outline-none tw-px-3 tw-py-2 tw-font-inter"
          (mousedown)="$event.preventDefault()"
          (click)="confirmArchivePersona()"
        >
          Yes, I'm sure
        </button>
        <button
          type="button"
          class="tw-flex tw-items-center tw-justify-center tw-border tw-text-gray-800 tw-bg-white hover:tw-bg-gray-100 tw-font-medium tw-rounded-md tw-text-sm focus:tw:outline-none tw-border-gray-200 tw-px-3 tw-py-2 tw-font-inter"
          (mousedown)="$event.preventDefault()"
          (click)="cancelArchivePersona()"
        >
          No, cancel
        </button>
    </div>
  </modal>
}
